import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LcaPatientsService {
  getLcaPatientsUrl: string = 'api/AdminLca/GetLcaPatients';
  searchLcaPatientsUrl: string = 'api/AdminLca/SearchLcaPatients';

  constructor(
    private http: HttpClient
  ) { }

  getLcaPatients(pageSize, currentPage): Observable<any> {
    let params = new HttpParams()
        .set('pageSize', pageSize)
        .set('currentPage', currentPage);

    return this.http.get(this.getLcaPatientsUrl, {params: params});
  }

  searchLcaPatient(searchString, pageSize, currentPage): Observable<any> {
    let params = new HttpParams()
        .set('pageSize', pageSize)
        .set('currentPage', currentPage)
        .set('patientNameOrReferralCodeOrPhone', searchString);

    return this.http.get(this.searchLcaPatientsUrl, {params: params});
  }
}
